import * as Adaptive from 'adaptivecards';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import { PersonaSize } from '@fluentui/react/lib/Persona';
import {
    useLivePersonaCard,
    PersonaCardBehaviorProps,
} from 'owa-persona/lib/components/PersonaCardBehavior';

export default class AdaptivePersonaControl extends Adaptive.CardElement {
    private email: string;
    private personaElement: HTMLElement;

    protected internalRender(): HTMLElement {
        this.personaElement = document.createElement('div');
        const personaControl = <PersonaPill emailAddress={this.email} name={''} />;

        ReactDOM.render(personaControl, this.personaElement);
        return this.personaElement;
    }

    remove(): boolean {
        if (this.personaElement) {
            ReactDOM.unmountComponentAtNode(this.personaElement);
            this.personaElement = null;
        }

        return super.remove();
    }

    getJsonTypeName(): string {
        return 'Persona';
    }

    renderSpeech(): string {
        return this.email;
    }

    public parse(json: any) {
        super.parse(json);
        this.email = json.email;
    }
}

export interface PersonaPillProps extends PersonaCardBehaviorProps {
    emailAddress: string;
}

function PersonaPill(props: PersonaPillProps) {
    const PersonaCardBehavior = useLivePersonaCard(props);
    let { emailAddress, name, mailBoxType } = props;
    return (
        <PersonaCardBehavior>
            <PersonaControl
                emailAddress={emailAddress}
                name={name}
                size={PersonaSize.size48}
                showPersonaDetails={false}
                mailboxType={mailBoxType}
            />
        </PersonaCardBehavior>
    );
}
